import { environment } from "@environments/environment";

const baseUrl = environment.api.base;
const baseUploadUrl = environment.api.baseUpload;
const scopeApi = `${environment.api.id}/api-access`;
const scopeApiAdmin = `${environment.api.id}/Luca.Admin`;
const scopeEzshare = `${environment.api.idEzshare}/Access-ezshare`;

const _protectedResourceMap: (string | string[])[][] = [
 
  [
    `${baseUrl}utils/ocr`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}caches`,
    [`${scopeApi}`],
  ],
  [`${baseUrl}analysis/start`,
    [`${scopeApi}`],
  ],
  [`${baseUrl}analysis/status`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}utils/requirements`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}utils/criteria`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}utils/data`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}users/authorization`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}users/*`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}users/user/*`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}users/user/*/check`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}trainings/date`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}trainings/*/findings`,
    [`${scopeApiAdmin}`],
  ],
  [
    `${baseUrl}trainings/*/opinions`,
    [`${scopeApiAdmin}`],
  ],
  [
    `${baseUrl}trainings/date`,
    [`${scopeApiAdmin}`],
  ],
  [
    `${baseUrl}trainings/dates`,
    [`${scopeApiAdmin}`],
  ],
  [
    `${baseUrl}trainings/models`,
    [`${scopeApiAdmin}`],
  ],
  [
    `${baseUrl}tests/parameters/*`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}tests`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}tests/suggested`,
    [`${scopeApiAdmin}`],
  ],
  [
    `${baseUrl}tests/details`,
    [`${scopeApiAdmin}`],
  ],
  [
    `${baseUrl}tests/dictionary/*/test`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}tests/dictionary/*/icr`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}summary-reports/*`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}summary-reports/*/draft`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}scores/ranges`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}scores/*`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}icrs`, 
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}icrs/observations`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}icrs/*/observations`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}icrs/observations/*`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}icrs/observations/list`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}icrs/*/informations`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}icrs/*/complete`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}efas`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}efas/*`,
    [`${scopeApiAdmin}`],
  ],
  [
    `${baseUrl}efas/*/save-time`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}efas/*/complete`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}efas/*/information`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}efas/history`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}convergences/lms`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}convergences/ezshare`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}convergences/users`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}dictionarys/keywords`,
    [`${scopeApi}`],
  ],
  [
    `${baseUrl}dictionarys/keywords/*`,
    [`${scopeApi}`],
  ],
  [
    `${baseUploadUrl}*`,
    [`${scopeEzshare}`],
  ],
];

export const protectedResources = _protectedResourceMap;
